import CustomText from './CustomText';
import {CustomTextProps} from './type';
import Font from '../../../appStyles/style/font';
import React from 'react';

import {StyleSheet, Text} from 'react-native';
import {useFontTheme} from '../../../appStyles/hooks/theme';

const H6Text: React.FC<CustomTextProps<Text>> = React.forwardRef(
  (props, ref) => {
    const fontTheme = useFontTheme(props.fontTheme || 'muli');
    const propsToSpread = {
      ...props,
      style: [styles.H6Text, {fontFamily: fontTheme[600].normal}, props.style],
    };
    return (
      <CustomText ref={ref} {...propsToSpread}>
        {props.children}
      </CustomText>
    );
  },
);

const styles = StyleSheet.create({
  H6Text: {
    ...Font.FontSize.fontH6,
  },
});

export default React.memo(H6Text);
